import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { IFilter } from 'src/app/library/interfaces/filters/filter';
import { FilterService } from 'src/app/library/services/filter/filter.service';

@Component({
    selector: 'filter-filtering',
    templateUrl: './filter-filtering.component.html',
    styleUrls: ['./filter-filtering.component.scss']
})
export class FilterFilteringComponent implements OnInit {
    constructor(private filterService: FilterService) {}

    ngOnInit() {}

    public selectFilter(obj: IFilter) {
        let config = this.filterService.filterConfig;
        let filterVal = config.filters.find(e => e.field == obj.field);
        //check if a filter option selection is active
        let activeFilterSelection = config.filters.find(
            e =>
                e.selected &&
                !e.options.find(x => x.isSelected) &&
                (!e.extraFilters || !e.extraFilters.find(i => i.selected))
        );
        if (activeFilterSelection) {
            activeFilterSelection.selected = false;
        }
        if (filterVal) {
            filterVal.selected = true;
            filterVal.added = new Date();
            this.filterService.filterConfig = config;
        }
    }

    get unselectedFilters$() {
        return this.filterService.filterConfig$.pipe(
            map(e => {
                if (e) {
                    return e.filters?.filter(x => !x.selected);
                }
            })
        );
    }
}
